'use strict';

angular.module('app.networkInfluencerList', [])

 .controller('networkInfluencerListCtrl', ['$scope', '$rootScope', '$http', '$state', 'adminService', function ($scope, $rootScope, $http, $state, adminService) {
        $scope.currentUser = $rootScope.currentUser;

        $scope.influencerList = [];
        $scope.limitChannelList = 5;
        $scope.showAllChannel = false;


        $scope.PlatformIcon = function (platform_id) {
            return adminService.getPlatformIcon(platform_id);
        }

        if($scope.currentUser.accessibility.leftMenu.showNetworks == true) {
            $scope.influencerList = $rootScope.allInfluencerByNetworkCompany;
        }

        $scope.searchInfluencers = function(event) {
            if (/[a-zA-Z0-9-_ ]/.test(event.key)) {
                for(var i = 0; i < $scope.influencerList.length; i++) {
                    if($scope.influencerList[i].domain.toLowerCase().indexOf(event.key.toLowerCase()) == 0) {
                        var checkbox = $("#selectInfluencer > .checkboxLayer.show .checkBoxContainer")
                        var item = checkbox.find('label')[i];
                        checkbox.animate({ scrollTop: item.parentElement.parentElement.offsetTop }, { duration: 'medium', easing: 'swing' });
                        break;
                    }
                }
            }
        }

        $scope.markChannel = function(id) {
            $(".channels ul li").removeClass('activePreferred');
            $(".channels ul li#channel_" + $rootScope.sideMenuSelections.channel).addClass('activePreferred');
        }

        $scope.networkSidebar_selectChannel = function(id){

            $scope.markChannel(id);

            $rootScope.sideMenuSelections.project = null;
            $rootScope.sideMenuSelections.keyword = null;
            $rootScope.sideMenuSelections.blog = null;
            $rootScope.sideMenuSelections.channel = id;           
            $rootScope.sideMenuSelections.influencerGroup = null;

            $rootScope.saveParams = {
                mention : 0,
                blog_id : 0,
                project_id : 0,
                channel: id ? id : 0,
                influencerGroup: 0,
                _workaround_group_id: 0
            };

            $rootScope.$broadcast('refreshDashboard', {});

            if($state.current.name == "home.influencerOverview" || $state.current.name == "home.blogPostOverview" || $state.current.name == "home.instagramPostOverview" || $state.current.name == "home.youtubePostOverview") {
                $state.transitionTo("home.dashboard", null, {
                    reload: false,
                    inherit: false,
                    notify: true
                });
            }        
        }

        $scope.networkSidebar_toggleAll = function(e){
            $(e.target).text($scope.showAllChannel ? 'Show All' : 'Hide');
            $scope.showAllChannel = !$scope.showAllChannel;
        }

        $scope.$watch('influencers', function(newValue, oldValue){
            if(newValue !== oldValue && newValue !== undefined) {
                if(newValue[0] != null){
                    $scope.selectedInfluencer = newValue[0];
                    $(".influencer-list.multiSelect .buttonLabel").html($(".influencer-list.multiSelect .buttonLabel").html().replace(/&nbsp;/g, ''));
                }
                
            }
        });
    }])